import { call, takeLatest, put } from "redux-saga/effects"
import {
  requestUserListByFilters,
  requestUpsertAppUser,
  requestDeleteAppUser,
  requestEmailsOfUsers,
  requestAddUser,
} from "appRedux/sagas/requests/usersList"
import {
  getUserListByFilters,
  getUserListByFiltersSuccess,
  upsertAppUser,
  upsertAppUserSuccess,
  addUser,
  addUserSuccess,
  deleteAppUser,
  deleteAppUserSuccess,
  getEmailsOfUsers,
  getEmailsOfUsersSuccess,
} from "appRedux/slices/usersList"
import { fetchError } from "appRedux/slices/common"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

function* handleGetUserListByFilters(params) {
  try {
    const data = yield call(requestUserListByFilters, params)
    yield put(getUserListByFiltersSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleGetEmailsOfUsers(params) {
  try {
    const data = yield call(requestEmailsOfUsers, params)
    yield put(getEmailsOfUsersSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpsertAppUserGenerator({ payload }) {
  try {
    const data = yield call(requestUpsertAppUser, payload)
    if (data && data.data) {
      yield put(upsertAppUserSuccess(data.data))
    }
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleAddUserGenerator({ payload }) {
  try {
    const data = yield call(requestAddUser, payload)
    yield put(addUserSuccess(data.data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleDeleteAppUserGenerator({ payload }) {
  try {
    const data = yield call(requestDeleteAppUser, payload)
    toastr.success("Action successfull!!")

    yield put(deleteAppUserSuccess(data.data))
  } catch (error) {
    toastr.error("Action Failed !!")
    yield put(fetchError(error))
  }
}

export default function* watcherSaga() {
  yield takeLatest(getUserListByFilters.type, handleGetUserListByFilters)
  yield takeLatest(upsertAppUser.type, handleUpsertAppUserGenerator)
  yield takeLatest(deleteAppUser.type, handleDeleteAppUserGenerator)
  yield takeLatest(getEmailsOfUsers.type, handleGetEmailsOfUsers)
  yield takeLatest(addUser.type, handleAddUserGenerator)
}
